import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import { coworldLayout } from "./coworld-layout.styles";

export function CoworldRunRoster({
  roster,
  playerPickers,
}: Readonly<{
  roster: readonly string[];
  playerPickers: readonly ReactNode[];
}>) {
  return (
    <section {...stylex.props(styles.roster)}>
      <h2 {...stylex.props(coworldLayout.heading)}>Players</h2>
      {roster.map((_, slot) => (
        <fieldset
          key={slot}
          aria-label={`Player ${slot + 1}`}
          {...stylex.props(styles.player)}
        >
          <span {...stylex.props(coworldLayout.muted)}>Player {slot + 1}</span>
          {playerPickers[slot]}
        </fieldset>
      ))}
    </section>
  );
}

const styles = stylex.create({
  roster: { display: "grid", gap: spacing.space8 },
  player: {
    borderWidth: 0,
    margin: 0,
    minWidth: 0,
    paddingInline: 0,
    display: "grid",
    gridTemplateColumns: "80px minmax(0, 1fr)",
    alignItems: "center",
    gap: spacing.space12,
    paddingBlock: spacing.space8,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.hairline,
  },
});
